import { apiPost } from "../shared/apiClient";
import { createCachedFetcher } from "../shared/cachedFetcher";

const fetchQuickRepliesRaw = createCachedFetcher(
  userId => apiPost("/wati_messages/fetch_quick_replies", { userId }).then(res =>
    res.data?.success ? (res.data.data?.items || []).sort((a, b) => (b.triggered || 0) - (a.triggered || 0)) : []
  ),
  { fallback: [] }
);

export function fetchQuickReplies(userId) {
  return fetchQuickRepliesRaw(userId);
}

const fetchTemplatesRaw = createCachedFetcher(
  userId => apiPost("/wati_messages/fetch_all_templates", { userId }).then(res =>
    res.data?.success ? (res.data.data || []).filter(t => t.status === "APPROVED") : []
  ),
  { fallback: [] }
);

export function fetchTemplates(userId, { force = false } = {}) {
  return fetchTemplatesRaw(userId, { force });
}

const fetchChatFilterTabsRaw = createCachedFetcher(
  userId => apiPost("/wati_messages/get_chat_filters", { userId }).then(res =>
    res.data?.success ? (res.data.data ?? []).filter(f => f.isDefault) : []
  ),
  { fallback: [] }
);

export function fetchChatFilterTabs(userId) {
  return fetchChatFilterTabsRaw(userId);
}
